import { render } from "./Vendedores.vue?vue&type=template&id=ee4e0d30"
import script from "./Vendedores.vue?vue&type=script&lang=js"
export * from "./Vendedores.vue?vue&type=script&lang=js"

import "./Vendedores.vue?vue&type=style&index=0&id=ee4e0d30&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__